import React from 'react';

function Careers() {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-800 text-white">
      <h1 className="text-3xl font-bold">Careers</h1>
    </div>
  );
}

export default Careers;
